module.exports = __webpack_public_path__ + "static/logo_alsassociation-7ead461e6b091a85cc896eb212c4c3b6.png";